/* ==========================================================
   IL MENU DEL TELEFONO: FRECCETTA PER APRIRE I MODELLI
   (26 agosto 2026)
   ==========================================================
   Questo file fa una cosa sola: dentro il cassetto del telefono,
   trasforma in gruppo apribile ogni categoria che ha davvero dei modelli
   sotto. Il vestito e' tutto in assets/cube-menu-mobile.css, che spiega
   il perche' della scelta.

   COSA MARCA E PERCHE'. Su ogni riga di categoria buona mette due
   attributi:
     data-cube-gruppo="1"  -> e' un gruppo apribile. Serve anche al CSS
                              come gancio: senza, il foglio non tocca
                              niente.
     data-cube-aperto="0"  -> chiuso. Diventa "1" quando si apre.
   Le categorie SENZA modelli sotto non vengono marcate e restano righe
   semplici, senza freccetta: e' il caso di TRAILER.

   IL TITOLO NON VIENE TOCCATO. Resta il link alla pagina della
   categoria: la freccetta e' un bottone a parte, aggiunto dopo il link.
   Sul click ferma la propagazione, se no il cassetto interpreterebbe il
   tocco come una navigazione e si chiuderebbe.

   PERCHE' L'OSSERVATORE. Il tema ricostruisce pezzi del cassetto quando
   si passa da un livello all'altro: le righe nuove nascono senza
   attributi e senza freccetta. L'osservatore rilancia la preparazione a
   ogni cambiamento. Non entra in ciclo: al secondo giro trova tutto gia'
   marcato, non modifica niente e il DOM non cambia piu'.

   PER SPEGNERLO basta togliere la riga che carica questo file da
   snippets/stylesheets.liquid.
   ========================================================== */

(function () {
  'use strict';

  function apriChiudi(e) {
    e.preventDefault();
    e.stopPropagation();
    var tasto = e.currentTarget;
    var riga = tasto.closest('.menu-drawer__list-item--flat');
    if (!riga) return;
    var aperto = riga.dataset.cubeAperto === '1' ? '0' : '1';
    riga.dataset.cubeAperto = aperto;
    tasto.setAttribute('aria-expanded', aperto === '1' ? 'true' : 'false');
  }

  function prepara() {
    var righe = document.querySelectorAll('.menu-drawer .menu-drawer__list-item--flat');
    for (var i = 0; i < righe.length; i++) {
      var riga = righe[i];
      if (riga.dataset.cubeGruppo === '1') continue;

      var titolo = riga.querySelector(':scope > .menu-drawer__menu-item--parent');
      var elenco = riga.querySelector(':scope > .menu-drawer__menu--grandchildlist');
      if (!titolo || !elenco || !elenco.children.length) continue;

      riga.dataset.cubeGruppo = '1';
      riga.dataset.cubeAperto = '0';

      var tasto = document.createElement('button');
      tasto.type = 'button';
      tasto.className = 'cube-mob-freccia';
      tasto.setAttribute('aria-expanded', 'false');
      tasto.setAttribute('aria-label', 'Mostra i modelli di ' + titolo.textContent.trim());
      tasto.addEventListener('click', apriChiudi);

      titolo.insertAdjacentElement('afterend', tasto);
    }
  }

  /* ---------- VEDI TUTTO in fondo a ogni sottomenu (13 ottobre 2026) ----------
     "non riesco a vedere per esempio la voce E-BIKE per intero ma solo le
     sottocategorie. quindi penso sia interessante mettere un tasto vedi
     tutte dentro in basso" - Marco.

     Nel cassetto le voci del primo livello (BIKE 2027, E-BIKE 2027...)
     sono solo apri-sottomenu: il tema non ci mette il link alla pagina
     intera, che c'e' invece nella striscia del menu sul computer. Il
     link lo prendiamo proprio da li' (a.menu-list__link, stessa lista di
     menu), cercando la voce con lo stesso nome, e in fondo all'elenco del
     sottomenu aggiungiamo una riga con il tasto "Vedi tutto BIKE 2027".

     Le voci senza una pagina vera (USATO e COMPONENTI/RICAMBI hanno
     come link la home, "/") non hanno il tasto: porterebbe in home.
     Gia' messo, non si rimette: stesso discorso dell'osservatore qui
     sotto, al secondo giro non cambia niente. */
  function vediTutto() {
    var indirizzi = {};
    var link = document.querySelectorAll('a.menu-list__link');
    for (var i = 0; i < link.length; i++) {
      var h = link[i].getAttribute('href') || '';
      if (!h || h === '/' || h.charAt(0) === '#') continue;
      indirizzi[link[i].textContent.trim().toUpperCase()] = h;
    }

    var voci = document.querySelectorAll('.menu-drawer summary.menu-drawer__menu-item--mainlist');
    for (var j = 0; j < voci.length; j++) {
      var nome = voci[j].textContent.trim();
      var dove = indirizzi[nome.toUpperCase()];
      if (!dove) continue;
      var elenco = voci[j].parentElement.querySelector(':scope > .menu-drawer__submenu .menu-drawer__inner-submenu > ul.menu-drawer__menu');
      if (!elenco || elenco.querySelector(':scope > .cube-mob-tutte')) continue;

      var riga = document.createElement('li');
      riga.className = 'cube-mob-tutte';
      var tasto = document.createElement('a');
      tasto.href = dove;
      tasto.textContent = 'Vedi tutto ' + nome;
      riga.appendChild(tasto);
      elenco.appendChild(riga);
    }
  }

  function avvia() {
    prepara();
    vediTutto();
    var cassetto = document.querySelector('.menu-drawer');
    if (!cassetto || !window.MutationObserver) return;
    new MutationObserver(function () {
      prepara();
      vediTutto();
    }).observe(cassetto, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }
})();
